<template>
  <el-row>
    <table-template :queryParams="queryParams" actionUrl="businessIntranet/findMySpreadOrderCarList.action"
                    ref="intranetSpreadRecordTable">
      <template slot="item">
        <el-table-column
            label="品牌车型"
            width="500px"
           >
          <template scope="scope">
            <p>{{scope.row.brand}} {{scope.row.series}}</p>
            <p>{{scope.row.category}}</p>

          </template>
        </el-table-column>
        <el-table-column
                label="推广效果"
        >
          <template slot-scope="scope">
            <p>浏览量：{{scope.row.spreadBrowseCount}}</p>
            <p>拨打量：{{scope.row.spreadBusinessBrowseCount}}</p>
          </template>
        </el-table-column>

      </template>
    </table-template>
  </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'intranetSpreadRecord',
  data: function () {
    return {
      queryParams: {
        id: null
      }
    }
  },
  created () {
    let query = this.$route.query
    this.queryParams.id = query.id
  },
  methods: {
    clueStatusColor: function (clueStatus) {
      let color = ''
      switch (clueStatus) {
        case 1:
          color = 'red'
          break
        case 2:
          color = '#FF8C00'
          break
        case 3:
          color = ''
          break
        case 4:
          color = 'green'
          break
      }
      return color
    },
    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
      this.$refs.intranetSpreadRecordTable.search()
    }
  },
  filters: {

    statusFilter: function (val) {
      let str = '非法值'
      switch (val) {
        case 1:
          str = '正在收车'
          break
        case 2:
          str = '排队收车'
          break
        case 3:
          str = '放弃收车'
          break
        case 4:
          str = '成功收车'
          break
        case 5:
          str = '锁定看车'
          break
      }
      return str
    }
  }
}
</script>

<style scoped>
</style>
